import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { COMPANY } from "@/data/site";

const LAT = 13.029034613702047;
const LNG = 77.60375662448612;
const MAP_EMBED = `https://maps.google.com/maps?q=${LAT},${LNG}&z=17&output=embed`;
const MAP_LINK = `https://www.google.com/maps/search/?api=1&query=${LAT},${LNG}`;

export default function ContactMap() {
  return (
    <section
      id="visit"
      data-testid="contact-map-section"
      className="section-pad relative"
    >
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-[#FFC857] mb-6">
              — Visit Us
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.1]">
              Step into our{" "}
              <span className="italic text-[#FFC857]">Bengaluru studio.</span>
            </h2>
            <p className="mt-6 text-[#A0ABC0] text-base md:text-lg font-light leading-relaxed">
              Our HQ in Sultan Palya is where every system is designed,
              engineered and dispatched from — walk in or schedule a visit and
              meet the team.
            </p>

            <div className="mt-10 space-y-5">
              <Row icon={MapPin} title="Address">
                {COMPANY.address}
              </Row>
              <Row icon={Phone} title="Phone">
                <div className="flex flex-col gap-1">
                  {COMPANY.phones.map((p) => (
                    <a
                      key={p}
                      data-testid={`map-phone-${p}`}
                      href={`tel:${p}`}
                      className="hover:text-white transition-colors"
                    >
                      +91 {p.slice(0, 5)} {p.slice(5)}
                    </a>
                  ))}
                </div>
              </Row>
              <Row icon={Mail} title="Email">
                <a
                  data-testid="map-email"
                  href={`mailto:${COMPANY.email}`}
                  className="hover:text-white transition-colors"
                >
                  {COMPANY.email}
                </a>
              </Row>
              <Row icon={Clock} title="Hours">
                Mon – Sat · 9:00 AM – 7:00 PM
              </Row>
            </div>

            <a
              data-testid="map-directions"
              href={MAP_LINK}
              target="_blank"
              rel="noreferrer"
              className="btn-outline-gold mt-10 inline-flex"
            >
              Get Directions <ExternalLink className="h-4 w-4" />
            </a>
          </div>

          <div className="lg:col-span-7">
            <div className="relative rounded-sm overflow-hidden border border-white/10 glass">
              <iframe
                data-testid="hq-map-iframe"
                title="Jashvi Energy HQ — Sultan Palya, Bengaluru"
                src={MAP_EMBED}
                className="w-full h-[480px] md:h-[560px] border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
              <div className="absolute top-4 left-4 glass px-4 py-3 rounded-sm pointer-events-none">
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#FFC857]">
                  Jashvi Energy HQ
                </div>
                <div className="text-xs text-white font-light mt-1">
                  Sultan Palya · Bengaluru
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Row({ icon: Icon, title, children }) {
  return (
    <div className="flex items-start gap-4">
      <div className="shrink-0 h-11 w-11 rounded-full glass flex items-center justify-center">
        <Icon className="h-4 w-4 text-[#FFC857]" />
      </div>
      <div>
        <div className="text-[11px] uppercase tracking-[0.25em] text-[#A0ABC0] mb-1">
          {title}
        </div>
        <div className="text-sm md:text-base text-white font-light leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
}
